import { FaExclamationTriangle, FaCalendarAlt } from 'react-icons/fa';

const CancelJobModal = ({
  saving,
  onClose,
  onReschedule,
  onConfirm,
}) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md">
        <h4 className="text-lg font-semibold mb-4 text-gray-800 flex items-center">
          <FaExclamationTriangle className="text-amber-500 mr-2" />
          Cancel this job?
        </h4>
        <div className="mb-4 text-sm text-gray-700 space-y-2">
          <p>
            Cancelling means this job will <strong>not be done</strong>. For a recurring job, only this visit is cancelled.
          </p>
          <p>
            If you plan to do this job on another day, <strong>reschedule</strong> it instead.
          </p>
        </div>
        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            disabled={saving}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 border border-gray-300 rounded-md shadow-sm hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 disabled:opacity-50"
          >
            Go Back
          </button>
          <button
            onClick={onReschedule}
            disabled={saving}
            className="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50"
          >
            <FaCalendarAlt className="mr-2" />
            Reschedule
          </button>
          <button
            onClick={onConfirm}
            disabled={saving}
            className="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-50"
          >
            {saving ? (
              <>
                <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Cancelling...
              </>
            ) : (
              'Yes, Cancel Job'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelJobModal;
